import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

// Connects to data-controller="notifications"
export default class extends Controller {
  static targets = ["container"];

  connect() {
    enter(this.containerTarget);
  }

  hide() {
    Promise.all([leave(this.containerTarget)]).then(() => {
      this.containerTarget.classList.add("hidden");
      this.containerTarget.remove();
    });
  }
}
